import React from 'react'

function PageTitle({title}) {
  return (
    <div className='mt-2'>
        <h1>{title}</h1>
    </div>
  )
}

export default PageTitle;